import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { Credentials, LoginContext } from './authentication.service';

export class MockAuthenticationService {

  credentials: Credentials | null = {
    username: 'test',
    token: '123',
    cpf: '123',
    profileImage: 'test',
    status: 1,
    accrediteds: []

};

  login(context: LoginContext): Observable<Credentials> {
    return of({
      username: context.username,
      token: '123456',
      cpf: '123',
      profileImage: 'test',
      status: 1,
      accrediteds: []
    });
  }

  logout(): Observable<boolean> {
    this.credentials = null;
    return of(true);
  }

  isAuthenticated(): boolean {
    return !!this.credentials;
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/authentication/authentication.service.mock.ts